import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import DonateForm from './components/DonateForm';
import Footer from './components/Footer';

/** Banner copy for the ?donation= status Payfast sends us back with. */
const DONATION_MESSAGES: Record<string, { className: string; text: string }> = {
    thanks: {
        className: 'thanks',
        text: 'Thank you. Your donation was received and Payfast has emailed you a receipt. Every rand helps us reach someone faster.',
    },
    cancelled: {
        className: 'cancelled',
        text: 'Your donation was cancelled and you have not been charged. You are welcome to try again whenever suits you.',
    },
    error: {
        className: 'error',
        text: 'Something went wrong setting up that payment and you have not been charged. Please try again, or use the banking details below.',
    },
};

const Donate: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const donationStatus = searchParams.get('donation');
    const donationMessage = donationStatus ? DONATION_MESSAGES[donationStatus] : undefined;

    const dismissDonationBanner = () => {
        const next = new URLSearchParams(searchParams);
        next.delete('donation');
        setSearchParams(next, { replace: true });
    };

    // Payfast returns the donor to /donate?donation=... Land them on the
    // banner rather than wherever the browser restored the scroll position to.
    useEffect(() => {
        if (donationMessage) {
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [donationStatus]);

    return (
        <div className="font-sans text-gray-800">

            {/* Hero Banner */}
            <section id="banner" className="hero-banner">
                <img src="/media/hero-banner.jpg" alt="Support Kilo Delta On Call" className="hero-banner-image" />
                <div className="hero-content">
                    <img alt="Kilo Delta Logo" src="/media/logo-full.png" className="logo-hero-banner" />
                    <h1>DONATE</h1>
                    <h2>HELP US KEEP ANSWERING</h2>
                </div>
            </section>

            {/* Donate */}
            <section id="donate" className="donations-section">
                {donationMessage && (
                    <div className={`donation-banner ${donationMessage.className}`} role="status">
                        <p>{donationMessage.text}</p>
                        <button
                            type="button"
                            className="donation-banner-close"
                            onClick={dismissDonationBanner}
                            aria-label="Dismiss message"
                        >
                            ✕
                        </button>
                    </div>
                )}

                <div className="donations-content">
                    <div className="donate-media">
                        <img
                            src="/media/thank-you-macpro.jpg"
                            alt="Thank you MacPro Panel Beaters, for sponsoring the canopy for our Emergency Support Vehicle"
                        />
                    </div>

                    <div className="donate-panel">
                        <DonateForm />

                        <div className="donation-amounts">
                            <h4>Prefer a direct EFT?</h4>
                            <ul>
                                <li><strong>Account Name:</strong> KILO DELTA ON CALL</li>
                                <li><strong>Bank:</strong> First National Bank</li>
                                <li><strong>Account Number:</strong> 63177193827</li>
                                <li><strong>Branch Code:</strong> 251037</li>
                                <li><strong>Reference:</strong> Donation (Your Name / Company)</li>
                            </ul>
                        </div>

                        <p className="donation-contact-note">
                            Donating for a company, or want to sponsor equipment?{' '}
                            <a href="mailto:info@kilodeltaoncall.org">Talk to us</a>.
                        </p>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Donate;
